import {createSlice, Dispatch, PayloadAction} from '@reduxjs/toolkit';
import i18n from 'i18next';
import Cookies from 'universal-cookie';
import {LanguagesEnum} from '../helpers/enums';
const cookies = new Cookies();

const initialState: any = {
   language:cookies.get(LanguagesEnum.default)

};


const languageSlice  = createSlice({
    name:"language",
    initialState,
    reducers:{
        changeLanguage(state, action: PayloadAction<string>): void {
            state.language = action.payload;
            i18n.changeLanguage(action.payload);
        }
    }
});


export const {
    changeLanguage
} = languageSlice.actions;
  
  
  export default languageSlice.reducer;
  
  export const languageHandler = (language: any) => (dispatch: Dispatch) => {
    return dispatch(changeLanguage(language));
  };
